module.exports = __webpack_public_path__ + "static/media/alice3.d64b6ed4.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/alice3.JPG
// module id = 54
// module chunks = 0